// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__321Th","row":"styles_row__28KY2"};